
import { Component, Prop,FormComponentBase} from "@/lib";

@Component({name:"hi-select"})
export default class HiSelect extends FormComponentBase {
  @Prop({ type: [String, Number, Array], default: "", required: true }) value: any;
  @Prop({ type: Array, default: () => { return []; }}) selectList: any[];
  @Prop({ type: Boolean, default: false }) multiple: boolean;
  @Prop({ type: Boolean, default: false }) number: boolean;
  @Prop({ type: Boolean, default: false }) labelInValue: boolean;
  @Prop({ type: Boolean, default: true }) clearable: boolean;
  @Prop({ type: Boolean, default: false }) transfer: boolean;

  get requiredRule() {
    if(!this.multiple){
      return {
              required: true, //是否必填
              type: this.number ? "number" : "string",
              message: this.L("Validate.PleaseSelect", this.L(this.labelKey)), //验证信息
              trigger: "change" //触发方式    常用  blur 和 change}
            };
    } else{
      return {
              required: true,
              type:"array",
              min:1,
              message : this.L("Validate.PleaseSelect", this.L(this.labelKey)),
              trigger: "change"
            };
    }    
  }

  change(value) {
    this.$emit("on-change", value);
  }

  clear() {
    this.$emit("on-clear");
  }
}
